import { types } from 'mobx-state-tree';
import type { Instance } from 'mobx-state-tree';

export const LibraryCollectionModel = types.snapshotProcessor(
    types.model('LibraryCollectionModel', {
        tag: types.string,
        title: types.string,
        description: types.string,
        datePublished: types.string,
        logo: types.string,
        authors: types.array(types.string),
        authorIds: types.array(types.string),
        collectionLink: '',
        metadata: types.maybeNull(types.string),
    }),
    {
        preProcessor(sn: any) {
            return {
                ...sn,
                authorIds: sn.authors.map((author: string) =>
                    author.replaceAll(' ', '_').toLowerCase()
                ),
                collectionLink: `/strata-library/sound-effects-collections/collection/${sn.tag}`,
            };
        },
    }
);

export type TypeLibraryCollectionModel = Instance<typeof LibraryCollectionModel>;

export default LibraryCollectionModel;
